import { type VideoPropsBase } from "./component";
import { getVideoId, isYouTubeURL } from "./YouTube/lib";

export const getAllow = (props: VideoPropsBase): string => "autoplay";

export type StorageInfo = {
  isPaused: boolean;
  seconds: number;
};

export const DEFAULT_STORAGE_INFO: StorageInfo = {
  isPaused: true,
  seconds: 0
};

export const getVideoThumbnail = (url: string): string | null => {
  // YouTube
  if (isYouTubeURL(url)) {
    const id = getVideoId(url);
    return `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
  }

  return null;
};
